import Product from "emun.shopping/product.model";
import shoppingConfig from "emun.shopping/shopping.config";
import resolve from "ioc/resolve";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import $session from "servicestack/session";

const identity = (m) => m;

export default class ProductQuery extends AutoQuery {
  constructor(options) {
    const aqOptions = (shoppingConfig.productQueryOptionsDecorator || identity)(
      Object.assign(
        {
          disableQueryString: false,
          url:
            shoppingConfig.queryProductsUrl ||
            `QueryProducts.json?op=ProductQuery1.1&JsConfig=ExcludeDefaultValues`, //&Fields=${options.fields}
          tagTotalsUrl: shoppingConfig.tagTotalsUrl || `QueryProductTagTotals.json?op=ProductQuery&ProductIdsToTake=0&JsConfig=ExcludeDefaultValues`,
          //autoLoad: shoppingConfig.autoLoad === true && !$session.salesManagementMode ? true : false,
          append: shoppingConfig.append === true ? true : false,
          pageSize: shoppingConfig.pageSize || 24,
          pageSizes: shoppingConfig.pageSizes || [6, 12, 24, 48, 72, 96],
          orderBy: shoppingConfig.orderBy,
          //fields: 'ProductTemplateId,OnDemandProductId,OnDemandProductLabel,ProductTemplateLabel,Ratio,Height,Width,Depth,Weight,Images,Areas,Active,Id,ManufacturerNumber,ShortDescription,LongDescription,Status,Pricing,ListPrice,WholesalePrice,RetailPrice,RetailListPrice,Price,MinimumOrderQty,AvailableQty,IncomingQty,PurchaseIncrement,OptionGroup,VendorId,IsB2B,IsB2C,IsSellable,ItemType,Keywords,SuperCategory,Tags,IsNew,IsRestricted,Meta,IsOnDemand,CreatedOn,Cost,Featured,Likes,HasLiked,ProductImages',
          sortOptions: shoppingConfig.sortOptions,
          afterProcessed: shoppingConfig.afterProcessed,
        },
        options
      ),
      resolve
    );
    if (
      aqOptions.includeInactive ||
      (aqOptions.criteria && aqOptions.criteria.includeInactive)
    ) {
      aqOptions.url += "&IncludeInactive=1";
      aqOptions.tagTotalsUrl += "&IncludeInactive=1";
    }

    super(aqOptions);
    const pq = this;
    pq.$cart = resolve("$cart");
    // console.warn("ProductQuery", {
    //   sortOptions: aqOptions.sortOptions,
    //   sortOptions$: pq.sortOptions,
    //   options,
    //   aqOptions,
    //   pq,
    // });
  }

  onInitialized() {
    super.onInitialized();
    const pq = this;
    const $rootScope = resolve("$rootScope");
    const $timeout = resolve("$timeout");
    const $state = resolve("$state");
    if (!(pq.orderBy in pq.sortOptions)) {
      pq.sortOptions[pq.orderBy] = shoppingConfig.defaultSortLabel;
    }
    // console.info("PQ", pq, pq.listeners, pq.$listeners);
    pq.$listeners.push($rootScope.$on("cartInitialized", (e) => goDoIt(e)));
    pq.$listeners.push(
      $rootScope.$on("cartReady", (e) => {
        goDoIt(e);
        pq.$listeners.push(
          $rootScope.$on(
            "$locationChangeSuccess",
            (e) => !pq.append && goDoIt(e)
          )
        );
      })
    );

    function goDoIt(ev) {
      // console.info(
      //   "pq.dontRead:",
      //   pq.dontRead,
      //   "pq.dontWrite:",
      //   pq.dontWrite,
      //   "pq.lastState:",
      //   pq.lastState,
      //   "$state.current.name:",
      //   $state.current.name,
      //   $state.current,
      //   ev,
      //   pq
      // );
      if (pq.dontRead) {
        delete pq.dontRead;
        return;
      }
      const reset = pq.calls === 0;
      $timeout(() => {
        if (pq.isIdle() && $state.current.name === "shop.multi-view") {
          // TODO: smelly, consider $stateChangeStart
          // console.log(
          //   "pq.load",
          //   $state.current.name,
          //   "dqs:",
          //   pq.disableQueryString,
          //   "idle:",
          //   pq.isIdle()
          // );
          !pq.disableQueryString && pq.readQueryString(reset);
          pq.load(reset);
        } else {
          console.warn(
            "pq.no-load",
            $state.current.name,
            "dqs:",
            pq.disableQueryString,
            "idle:",
            pq.isIdle()
          );
        }
      }, 88);
    }
  }

  afterLoaded(args) {
    const pq = this;
    pq.images = args.results.map((prod) => ({
      id: prod.id,
      title: prod.id,
      desc: prod.shortDescription,
      thumbUrl: prod.getImageUrl("small"),
      bubbleUrl: prod.getImageUrl("small"),
      extUrl: prod.getImageUrl("hires"),
      url: prod.getImageUrl("large"),
      instock: prod.availableQty > 0 ? true : false,
      product: prod,
      //onOrder: foundItem ? true : false,
      price: prod.price,
    }));
  }

  onLoading(args) {
    let $request = super.onLoading(args);
    let $cart = resolve("$cart");
    $request.retailerId = $cart.retailerId || $session.retailerId;
    return $request;
  }
  scrub(response) {
    response.data.results = response.data.results.map((p) => new Product(p));
  }
}
